import React from 'react'
import PropTypes from 'prop-types'

export default function ActionbarComponent(props) {
  return (
    <div className="c-content__header-actions row--mb">
      {props.actions.map((action, i) => {
        const activeClass = action.active ? 'c-content__header-action--active' : '';
        return (
          <button 
            key={i}
            className={`c-content__header-action ${activeClass} col--stretch`}
            onClick={action.onClick} 
            disabled={action.disabled}
          >
            {action.label}
          </button>
        )
      })}
    </div>
  )
}